// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nGoCdBaaqkcmDkQm {
  width: 180px;
  height: 120px;
  border-radius: 2px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px dashed #2c99ff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ZN_957DhA2UgjuQ8 {
  color: #666666;
  font-size: 14px;
  line-height: 19px;
  margin-top: 8px;
}
.vSRgCFe8fIIVepLl {
  width: 32px;
  height: 32px;
}
.zxZqAA0XsMVvMbmB {
  font-size: 14px;
  color: #999999;
  line-height: 18px;
}
.custom_upload .ant-upload {
  width: 180px !important;
  height: 120px !important;
}
.custom_upload .ant-upload-list-item-container {
  width: 180px !important;
  height: 120px !important;
  position: relative;
  box-sizing: border-box;
}
.custom-item-renderer {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  border: 1px solid rgba(44, 153, 255, 0.5);
}
.custom-item-renderer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-sizing: border-box;
  position: static;
  object-fit: contain;
}
.mask-r {
  position: absolute;
  width: 48px;
  height: 24px;
  background: rgba(0, 0, 0, 0.6);
  right: 0;
  bottom: 0;
  text-align: center;
  line-height: 24px;
  display: flex;
  align-items: center;
}
.mask-r > div {
  width: 24px;
}
.mask-icon {
  color: #fff;
  display: inline-block;
  vertical-align: middle;
}
.preview {
  margin-right: 4px;
  display: inline-block;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/Upload/index.modules.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;AACA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AACF;AACA;EACE,WAAA;EACA,YAAA;AACF;AACA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AACF;AAEA;EAGM,uBAAA;EACA,wBAAA;AAFN;AAFA;EAOM,uBAAA;EACA,wBAAA;EACA,kBAAA;EAEA,sBAAA;AAHN;AARA;EAeI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;AAJJ;AAdA;EAoBM,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAtBA;EA6BI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAJJ;AAlCA;EAwCM,WAAA;AAHN;AArCA;EA4CI,WAAA;EACA,qBAAA;EACA,sBAAA;AAJJ;AA1CA;EAiDI,iBAAA;EACA,qBAAA;EACA,sBAAA;AAJJ","sourcesContent":[".uploadCt {\n  width: 180px;\n  height: 120px;\n  border-radius: 2px;\n  background: #ffffff;\n  box-sizing: border-box;\n  border: 1px dashed #2c99ff;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.uploadText {\n  color: #666666;\n  font-size: 14px;\n  line-height: 19px;\n  margin-top: 8px;\n}\n.UploadIcon {\n  width: 32px;\n  height: 32px;\n}\n.uploadTips {\n  font-size: 14px;\n  color: #999999;\n  line-height: 18px;\n}\n\n:global {\n  .custom_upload {\n    .ant-upload {\n      width: 180px !important;\n      height: 120px !important;\n    }\n    .ant-upload-list-item-container {\n      width: 180px !important;\n      height: 120px !important;\n      position: relative;\n      \n      box-sizing: border-box;\n    }\n  }\n  .custom-item-renderer {\n    width: 100%;\n    height: 100%;\n    border-radius: 2px;\n    border: 1px solid rgba(44, 153, 255, 0.5);\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      box-sizing: border-box;\n      position: static;\n      object-fit: contain;\n    }\n  }\n  .mask-r {\n    position: absolute;\n    width: 48px;\n    height: 24px;\n    background: rgba(0, 0, 0, 0.6);\n    right: 0;\n    bottom: 0;\n    text-align: center;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    > div {\n      width: 24px;\n    }\n  }\n  .mask-icon {\n    color: #fff;\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .preview {\n    margin-right: 4px;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploadCt": `nGoCdBaaqkcmDkQm`,
	"uploadText": `ZN_957DhA2UgjuQ8`,
	"UploadIcon": `vSRgCFe8fIIVepLl`,
	"uploadTips": `zxZqAA0XsMVvMbmB`
};
export default ___CSS_LOADER_EXPORT___;
